import React from "react";
import { Paper, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { selectLocalization } from "@/store/store/selectors";
import { getLocalisationVal } from "@/utils/localizationUtil";
import { Colors } from "@/theme";
import moment from "moment";
import useStyles from "./styles";

const CustomTooltip = (props) => {
  const { itemData, series } = props;
  const classes = useStyles();
  const localization = useSelector(selectLocalization);
  if (itemData.dataIndex === undefined) return null;

  return (
    <Paper
      sx={{
        backgroundColor: Colors.GREEN_LIGHT,
        borderRadius: 4,
        borderColor: Colors.GRAY_BORDER,
        borderWidth: 1,
      }}
    >
      <Box px={4} py={1}>
        <span className={classes.tooltipText} style={{ color: series.color }}>
          {getLocalisationVal(localization, series.data[itemData.dataIndex])}
        </span>
      </Box>
    </Paper>
  );
};

export default CustomTooltip;
